export function getMutationTable(tableName: string) {
  return `$${tableName}_mutations`;
}
